import xdMiniGameApi from "apis/xd-minigame-api";
import { RootState, useAppSelector } from "cache/store";
import { ParamBetMiniXD, PayloadBodyTopicXD, StatsCountMiniXD } from "models/mini-xd-model";
import { ChatItemTXCB, PayloadBodyUserQueueTXCB } from "models/txcb-model";
import { useEffect, useRef, useState } from "react";
import xdFunction, { chatSuggestXD } from "./xd-function";
import xdSocket from "socket/xocdia-socket";
import BoardXd from "./board-xd/board-xd";
import StatsMiniXD from "./stats-mini-xd";
import BoxChatMinigame from "components/BoxChatMinigame/box-chat-minigame";
import './xocdia.scss';
import Modal from "components/modal/Modal";
import HDXDMiniGame from "./hd/hd";
import LSCXDMiniGame from "./lsc/lsc";
import MiniRank from "../bxh/bxh";

interface Props {
    onClose: () => void;
    onChangeMsg: (inputData: string) => void;
}
export default function XocDiaMiniGame(props: Props) {
    const { onClose, onChangeMsg } = props;

    const maintainXD = useRef(false);
    const pageDom = useRef<HTMLDivElement>(null);
    const hisPhienData = useRef<{ id: string; result: number[] }[]>([]);
    const { stompXD } = useAppSelector((state: RootState) => state.socket);
    const { userInfo, tokenXD } = useAppSelector((state: RootState) => state.auth);

    const [XDTopicData, setXDTopicData] = useState({} as PayloadBodyTopicXD);
    const [TXCBUserQueueData, setTXCBUserQueueData] = useState({} as PayloadBodyUserQueueTXCB);

    const [showRank, setShowRank] = useState(false);
    const [rankData, setRankData] = useState<any[]>([]);

    const [showHistoryMyBet, setShowHistoryMyBet] = useState(false);

    const [showHelp, setShowHelp] = useState(false);

    const [showChat, setShowChat] = useState(false);
    const [chatList, setChatList] = useState<ChatItemTXCB[]>([]);
    const [isMuted, setIsMuted] = useState(false);

    const [statsData, setStatsData] = useState({} as StatsCountMiniXD);
    const [hisIssueList, setHisIssueList] = useState<number[][]>([]);

    useEffect(() => {
        if (stompXD) {
            stompXD.subscribe('/topic/xd', (data: { body: string }) => {
                const body: PayloadBodyTopicXD = JSON.parse(data.body);
                if (body.cmd === 12 && body.rs) {
                    maintainXD.current = true;
                }

                //chat response
                if (body.cmd === 11) {
                    setChatList((list) => {
                        if (list.length > 0) {
                            return [...list, body.data[body.data.length - 1]];
                        } else {
                            return [...list, ...body.data];
                        }
                    });
                }
                setXDTopicData(body);
            });

            stompXD.subscribe('/user/queue/xd', (data: any) => {
                const body: PayloadBodyUserQueueTXCB = JSON.parse(data.body);
                setTXCBUserQueueData(body);

                //chat
                if (body.cmd === 11) {
                    const lastMsg = body.data[body.data.length - 1];
                    setChatList((list) => [...list, lastMsg as any]);
                }
            });
        }
    }, [stompXD]);

    useEffect(() => {
        const getStatsRecord = async () => {
            try {
                const { data } = await xdMiniGameApi.getStatistic();
                if (Array.isArray(data)) {
                    const statsData = xdFunction.calcstatsTotal(
                        data.map((item) => ({ ...item, result: JSON.parse(item.result) })),
                        {} as StatsCountMiniXD
                    );
                    if (data.length > 0) {
                        let hisIssueData: number[][] = [];
                        data.forEach((issue) => {
                            const result: number[] = JSON.parse(issue.result);
                            hisIssueData = [result, ...hisIssueData];
                        });
                        if (hisIssueData.length > 10) {
                            hisIssueData = hisIssueData.slice(-9);
                        }
                        setHisIssueList(hisIssueData);
                    }

                    setStatsData(statsData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatsRecord();
    }, []);

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    const submitBet = (topic: string, payload: ParamBetMiniXD) => {
        if (stompXD && stompXD.connected) {
            payload = { ...payload, userId: userInfo.id, loginname: userInfo.loginname, userType: userInfo.usertype };
            xdSocket.sendMessage(topic, payload);
        }
    };

    const getRank = async () => {
        setShowRank(true);
        const params = {
            type: 3,
            access_token: tokenXD || '',
        };
        try {
            const { data } = await xdMiniGameApi.getRank(params);
            const topTen = (data as any)
                .filter((item: any) => item.amount && item.amount > 0)
                .sort((a: any, b: any) => b['amount'] - a['amount'])
                .slice(0, 10);
            setRankData(topTen);
        } catch (error) {
            console.log(error);
        }
    };

    const sendChat = (msg: string, cb: () => void) => {
        if (Number(userInfo.balance) < 20000) {
            handleGetMsg('Số dư của bạn phải trên 20,000 để có thể chat!');
            return;
        }
        const payload = {
            u: userInfo.loginname,
            m: msg,
        };
        xdSocket.sendMessage('/topic/xd/chat', payload);
    };

    const toggleSound = () => {
        setIsMuted(!isMuted);
    };

    return (
        <div className="page-xd">
            <div className="content-mini-xd">
                <div className="xd-mini-page" ref={pageDom}>
                    <div className="wrap-game">
                        <div className="board-game">
                            <div className="btn-header-list">
                                <div className="btn-group">
                                    <button className="btn-reset" onClick={getRank}>
                                        <img src={require(`assets/images/txcb/btn-rank.png`)} alt="" />
                                    </button>

                                    <button className="btn-reset" onClick={() => setShowHistoryMyBet(true)}>
                                        <img src={require(`assets/images/txcb/btn-his-bet.png`)} alt="" />
                                    </button>
                                    <button className="btn-reset" onClick={toggleSound}>
                                        {isMuted ? (
                                            <img src={require(`assets/images/icons/sound-off.png`)} alt="" />
                                        ) : (
                                            <img src={require(`assets/images/icons/sound-on.png`)} alt="" />
                                        )}
                                    </button>
                                </div>
                                <div className="btn-group">
                                    <button className="btn-reset" onClick={() => setShowHelp(true)}>
                                        <img src={require(`assets/images/txcb/btn-help.png`)} alt="" />
                                    </button>
                                    <button className="btn-reset" onClick={() => setShowChat(!showChat)}>
                                        {!showChat ? (
                                            <img src={require(`assets/images/icons/chat-off.png`)} alt="" />
                                        ) : (
                                            <img src={require(`assets/images/icons/chat-on.png`)} alt="" />
                                        )}
                                    </button>
                                    <button className="btn-reset" onClick={onClose}>
                                        <img src={require(`assets/images/txcb/btn-close.png`)} alt="" />
                                    </button>
                                </div>
                            </div>
                            <BoardXd
                                ref={pageDom}
                                balance={userInfo.balance}
                                bodyTopic={XDTopicData}
                                userQueue={TXCBUserQueueData}
                                onBet={submitBet}
                                lspData={hisPhienData.current}
                                onUpdatePhien={(value) => (hisPhienData.current = value)}
                                isMuted={isMuted}
                                onChangeMsg={handleGetMsg}
                            />
                        </div>
                    </div>
                    <div className={`chat-box ${showChat ? 'show' : ''}`}>
                        <StatsMiniXD statsData={statsData} hisIssueList={hisIssueList} />
                        <BoxChatMinigame
                            chatList={showChat ? chatList : []}
                            chatSuggest={chatSuggestXD}
                            onSend={sendChat}
                            onClose={() => setShowChat(false)}
                        />
                    </div>
                </div>

            </div>

            <Modal isShow={showHelp} onClose={() => setShowHelp(false)} width="920px">
                <HDXDMiniGame onClose={() => setShowHelp(false)} />
            </Modal>

            <Modal isShow={showRank} onClose={() => setShowRank(false)} width="920px">
                <MiniRank rankList={rankData} onClose={() => setShowRank(false)} />
            </Modal>
            <Modal isShow={showHistoryMyBet} onClose={() => setShowHistoryMyBet(false)} width="920px">
                <LSCXDMiniGame onClose={() => setShowHistoryMyBet(false)} />
            </Modal>
        </div>
    );
}
